import { PaginationAPI } from '@/types/pagination';
import { Pagination } from '@/constants/pagination';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuditType } from '@/types/audit';



export type AuditState = {
    data: AuditType[];
    pagination: PaginationAPI;
    loading: boolean;
};

export const auditInitialState: AuditState = {
    data: [],
    pagination: {
        Page: Pagination.Page,
        totalPages: 0,
        totalElements: 0,
        Size: Pagination.Size,
    },
    loading: false,
};

const slice = createSlice({
    name: 'audit',
    initialState: auditInitialState,
    reducers: {
        setListAuditAction(
            state,
            action: PayloadAction<{
                data: AuditType[];
                pagination?: PaginationAPI;
                totalExtend?: number;
                append?: boolean;
            }>,
        ) {
            const { payload } = action;

            if (payload.append) {
                // Append new data to existing data
                state.data = [...state.data, ...payload.data];
            } else {
                // Replace existing data
                state.data = payload.data;
            }

            state.pagination = payload.pagination || state.pagination;
        },
        setAuditLoading(state, action: PayloadAction<boolean>) {
            state.loading = action.payload;
        },
    },
});

export const {
    setListAuditAction,
    setAuditLoading,
} = slice.actions;
export default slice.reducer;